import React from 'react';
import parse from 'html-react-parser';
import { TCard } from '../../utils/types';
import CardTooltip from '../CardTooltip';
import Graphics from '../Graphics';
import { IconCircleArrow } from '../../utils/icons';

export interface CardProps {
  cardData: TCard
}

const Card = ({ cardData }: CardProps) => {

	const { Title, Text, Graphic, Link, LinkText, VisRoedBaggrund, ButtonLink1, MatomoId, Icon } = cardData;
	const TooltipData = cardData.Tooltip;

	return (
		<>
			{ !Link && !ButtonLink1 && (
				<div className="lhp-card new" id={ MatomoId }>
					<div className="card-content">
						<div className="icon-content">
							{ Graphic && <Graphics data={ { Type: !Graphic.Type && Icon ? 'Image' : Graphic.Type, Url: !Graphic.Url && Icon ? Icon : Graphic.Url } } /> }
						</div>
						<div className="text-content">
							<h4>{ Title }</h4>
							{ Text && parse(Text) }
							{ TooltipData && <CardTooltip tooltipData={ TooltipData } /> }
						</div>
					</div>
				</div>
			) }

			{ (Link || ButtonLink1) && !VisRoedBaggrund && (
				<a href={ Link || ButtonLink1 } target="_blank" className="lhp-card" rel="noreferrer" id={ MatomoId }>
					<div className="card-content">
						<div className="icon-content">
							{ Graphic && <Graphics data={ { Type: !Graphic.Type && Icon ? 'Image' : Graphic.Type, Url: !Graphic.Url && Icon ? Icon : Graphic.Url } } /> }
						</div>
						<p className="title">{ Title }</p>
						<span className="text-content">{ parse(Text) }</span>
						{ TooltipData && <CardTooltip tooltipData={ TooltipData } /> }
						<button className="btn-arrow" aria-label="open">
							<IconCircleArrow />
						</button>
					</div>
				</a>
			) }

			{ Link && VisRoedBaggrund && (
				<a href={ Link } target="_blank" className="lhp-card" rel="noreferrer" id={ MatomoId }>
					<div className="card-content card-content--red">
						<span className="f24">{ parse(Text) }</span>
						{ TooltipData && <CardTooltip tooltipData={ TooltipData } /> }
						<a type="button" className="square-button button-type-5 button-full-width" href={ Link }>{ LinkText }</a>
					</div>
				</a>
			) }
		</>
	);
};

export default Card;